var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef, useState } from 'react';
import classNames from 'classnames';
import { DocumentActions } from 'src/ui/views/dynamics/CaseGlobalViewPage/components/documents/DocumentActions';
import { Icons } from 'src/ui/components/Icons/Icons';
import { Avatar } from 'src/ui/views/dynamics/CaseGlobalViewPage/components/documents/Avatar';
import { MRZChecker } from 'src/ui/views/dynamics/CaseGlobalViewPage/components/MRZChecker/MRZChecker';
import { DocumentDetails } from 'src/ui/views/dynamics/CaseGlobalViewPage/components/documents/DocumentDetails';
import { getColorByStatus } from 'src/shared/helpers/viewsHelpers';
import { getPropsByKeyPath } from 'src/shared/helpers/objHelpers';
import { useUpdate } from 'src/shared/hooks/useLifecycle';
import { E_STATUS } from 'src/shared/types';
import { E_ICONS } from 'src/ui/components/Icons/constants';
import { COLORS } from 'src/shared/styles/colors';
import styles from './DocumentItem.module.scss';
var getControlsTextOverviewByStatus = function (i18n, status) {
    switch (status) {
        case E_STATUS.OK:
            return getPropsByKeyPath(i18n.keyValueMap, 'caseGlobalView.overview.status.ok');
        case E_STATUS.UNKNOWN:
            return getPropsByKeyPath(i18n.keyValueMap, 'caseGlobalView.overview.status.na');
        case E_STATUS.KO:
            return getPropsByKeyPath(i18n.keyValueMap, 'caseGlobalView.overview.status.ko');
        default:
            return '';
    }
};
export var DocumentItem = function (props) {
    var _a, _b, _c;
    var _d;
    var document = props.document, i18n = props.i18n, isCurrent = props.isCurrent, updatedDocumentData = props.updatedDocumentData, onClick = props.onClick, onStatusChange = props.onStatusChange, onMRZInputFocus = props.onMRZInputFocus, onSeeAllControl = props.onSeeAllControl, onMrzLinesChange = props.onMrzLinesChange;
    var controls = document.controls, label = document.label, machineKYC = document.machineKYC, extractedData = document.extractedData, nbOfFiles = document.nbOfFiles, preview = document.preview, status = document.status, decisionDisabled = document.decisionDisabled;
    var _e = useState(false), controlsListOpen = _e[0], setControlsListOpen = _e[1];
    var _f = useState(false), isMrzOpen = _f[0], setIsMrzOpen = _f[1];
    var detailsContainerRef = useRef(null);
    useUpdate(function () {
        if (!isCurrent && controlsListOpen) {
            setControlsListOpen(false);
            setIsMrzOpen(false);
        }
    }, [isCurrent]);
    useEffect(function () {
        if (isMrzOpen && detailsContainerRef.current) {
            //scrollTop container
            detailsContainerRef.current.scrollTo({
                top: 0,
                behavior: 'auto',
            });
        }
    }, [isMrzOpen, detailsContainerRef]);
    // CLASS
    var overviewWrapperClassName = classNames(styles.overviewWrapper, (_a = {},
        _a[styles.selectedItem] = isCurrent,
        _a));
    var controlsListClassName = classNames(styles.controlsListWrapper, (_b = {},
        _b[styles.controlsListWrapperOpen] = controlsListOpen,
        _b));
    var seeMoreClassName = classNames(styles.seeMore, (_c = {}, _c[styles.seeMoreOpen] = controlsListOpen, _c));
    // TEXT
    var nbOfControlsLabel = machineKYC
        ? getControlsTextOverviewByStatus(i18n, machineKYC.status).replace('$nbControl', machineKYC.nbOfControls)
        : '';
    var seeMoreLabel = getPropsByKeyPath(i18n.keyValueMap, 'caseGlobalView.components.documentItem.seeMore');
    // METHOD
    var handleOnClickItem = function () {
        if (isCurrent) {
            setControlsListOpen(!controlsListOpen);
        }
        onClick(document);
    };
    var handleOnStatusChange = function (status) {
        onStatusChange(document, status);
    };
    var haveDetails = controls.collection.length > 0;
    return (_jsxs("li", __assign({ className: styles.documentItemWrapper }, { children: [_jsxs("div", __assign({ className: overviewWrapperClassName, onClick: handleOnClickItem }, { children: [_jsx(Avatar, { src: preview, nbDocument: nbOfFiles, alt: "preview document" }), _jsxs("div", __assign({ className: styles.overviewContent }, { children: [_jsxs("div", __assign({ className: styles.contentHeaderWrapper }, { children: [_jsx("p", __assign({ className: styles.documentKYCItemTitle }, { children: label })), _jsx(DocumentActions, { status: status.value, isLoading: status.isLoading, locked: false, disabled: decisionDisabled, onStatusChange: handleOnStatusChange })] })), _jsxs("div", __assign({ className: styles.contentFooterWrapper }, { children: [machineKYC && controls.collection.length && (_jsxs("div", __assign({ className: styles.documentKYCInfoWrapper }, { children: [_jsx(Icons, { icon: E_ICONS.INFO, color: getColorByStatus(machineKYC.status) }), _jsx("p", __assign({ className: styles.documentKYCInfo, style: { color: getColorByStatus(machineKYC.status) } }, { children: nbOfControlsLabel }))] }))), haveDetails && (_jsxs("div", __assign({ className: seeMoreClassName, onClick: function () { return setControlsListOpen(!controlsListOpen); } }, { children: [_jsx("span", { children: seeMoreLabel }), _jsx(Icons, { icon: E_ICONS.ARROW_RIGHT, color: COLORS.PRIMARY['500'] })] })))] }))] }))] })), _jsx("div", __assign({ ref: detailsContainerRef, className: controlsListClassName }, { children: isMrzOpen ? (_jsx(MRZChecker, { i18n: i18n, mrzLines: ((_d = document.extractedData) === null || _d === void 0 ? void 0 : _d.mrz) || [], updatedDocumentData: updatedDocumentData, onClose: function () { return setIsMrzOpen(false); }, onInputFocus: onMRZInputFocus, onMrzLinesChange: onMrzLinesChange })) : (haveDetails && (_jsx(DocumentDetails, { i18n: i18n, controls: controls, extractedData: extractedData.all, onMRZClick: function () { return setIsMrzOpen(true); }, onSeeAllControl: onSeeAllControl }))) }))] })));
};
